var _g, _path, _path2, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailedNewIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_27673_4133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.0003 69.066C54.7102 69.066 69.0669 54.7092 69.0669 36.9993C69.0669 19.2894 54.7102 4.93262 37.0003 4.93262C19.2903 4.93262 4.93359 19.2894 4.93359 36.9993C4.93359 54.7092 19.2903 69.066 37.0003 69.066Z",
    fill: "url(#paint0_radial_27673_4133)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 6.16602C54.0287 6.16602 67.8338 19.9704 67.834 36.999C67.834 54.0278 54.0288 67.833 37 67.833C19.9713 67.8329 6.16699 54.0277 6.16699 36.999C6.16713 19.9705 19.9714 6.16616 37 6.16602Z",
    stroke: "black",
    strokeOpacity: 0.15,
    strokeWidth: 2.46667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0667 49.3326C44.3274 49.3326 54.2667 39.3933 54.2667 27.1326C54.2667 14.8719 44.3274 4.93262 32.0667 4.93262C19.806 4.93262 9.8667 14.8719 9.8667 27.1326C9.8667 39.3933 19.806 49.3326 32.0667 49.3326Z",
    fill: "url(#paint1_radial_27673_4133)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_27673_4133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0811 27.4064C51.0444 26.4431 51.0444 24.8813 50.0811 23.918C49.1178 22.9547 47.556 22.9547 46.5927 23.918L23.9182 46.5926C22.9549 47.5559 22.9549 49.1177 23.9182 50.081C24.8815 51.0443 26.4433 51.0443 27.4066 50.081L50.0811 27.4064Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_27673_4133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4064 23.9189C26.4431 22.9556 24.8813 22.9556 23.918 23.9189C22.9547 24.8822 22.9547 26.444 23.918 27.4073L46.5926 50.0818C47.5559 51.0451 49.1177 51.0451 50.081 50.0818C51.0443 49.1185 51.0443 47.5567 50.081 46.5934L27.4064 23.9189Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_27673_4133",
    x: 4.93359,
    y: 4.93262,
    width: 64.1333,
    height: 65.1205,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.986667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.493333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_27673_4133"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_27673_4133",
    x: 21.2225,
    y: 23.1953,
    width: 31.5546,
    height: 31.8017,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.22
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.986667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27673_4133"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27673_4133",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_27673_4133",
    x: 21.222,
    y: 23.1963,
    width: 31.5546,
    height: 31.8017,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.22
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.986667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27673_4133"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27673_4133",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_27673_4133",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3211.6 2570.27) scale(4489.33)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E84444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83030"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_27673_4133",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1697.07 1336.93) scale(2220)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedNewIcon);
export default __webpack_public_path__ + "static/media/failedNewIcon.7143af0b5e0d387d7d826e0a395cc36f.svg";
export { ForwardRef as ReactComponent };